import { Chip } from "@mui/material";
import { ButterCup, Christine, Greeny, Neutrals, Primary, SemanticError, SemanticInfo, SemanticSuccess, Warning } from "../../../core-components/theme/color-palette/colors";
import SpriteIcon from "../../../core-components/assets/Icon";

const getIconClass = (type: string) => {
    switch (type.toLowerCase().replaceAll(' ', '')) {
        case 'manual':
            return <SpriteIcon id='manual_batch_icon' width={16} height={16} />;
        case 'automated':
            return <SpriteIcon id='automated_batch_icon' width={16} height={16} />;
        case 'bypass':
            return <SpriteIcon id='bypass_batch_icon' width={16} height={16} />;
        case 'regular':
            return <SpriteIcon id='regular_batch_icon' width={16} height={16} />;
        case 'planned':
            return <SpriteIcon id='planned_batch_icon' width={16} height={16} />;
        case 'running':
            return <SpriteIcon id='running_batch_icon' width={16} height={16} />;
        case 'paused':
            return <SpriteIcon id='paused_batch_icon' width={16} height={16} />;
        case 'completed':
            return <SpriteIcon id='completed_batch_icon' width={16} height={16} />;
        case 'failed':
            return <SpriteIcon id='failed_batch_icon' width={16} height={16} />;
        case 'status':
            return <SpriteIcon id='status_batch_icon' width={16} height={16} />;
        case 'event_completion':
            return <SpriteIcon id='eventcompletion_batch_icon' width={16} height={16} />;
        case 'eventcompletion':
            return <SpriteIcon id='eventcompletion_batch_icon' width={16} height={16} />;
        case 'timecycle':
            return <SpriteIcon id='timecycle_batch_icon' width={16} height={16} />;
        case 'time_cycle':
            return <SpriteIcon id='timecycle_batch_icon' width={16} height={16} />;
        default:
            return <SpriteIcon id='regular_batch_icon' width={16} height={16} />;
    }
};

const getColor = (type: string) => {
    switch (type.toLowerCase()) {
        case 'manual':
            return Christine[600];
        case 'automated':
            return Primary[600];
        case 'bypass':
            return ButterCup[600];
        case 'regular':
            return Greeny[600];
        case 'planned':
            return SemanticInfo[900];
        case 'running':
            return Warning[600];
        case 'paused':
            return Neutrals[300];
        case 'completed':
            return SemanticSuccess[900]
        case 'failed':
            return SemanticError[900]
        case 'status':
            return Neutrals[900]
        case 'event_completion':
            return SemanticInfo[500]
        case 'time_cycle':
            return Christine[600]
        default:
            return Greeny[600];
    }
};

export const getBatchConfigTypeIconAndColor = (type: string) => ({
    iconClass: getIconClass(type),
    color: getColor(type),
});


export const getChipForDetectionType = (detectionType: string) => {
    return (
        <Chip
            icon={getIconClass(detectionType)}
            key={detectionType}
            label={detectionType}
            sx={{
                color: detectionType.toLowerCase().replaceAll(' ', '') === 'eventcompletion' ? SemanticInfo[500] : Christine[600],
                backgroundColor: 'white',
                border: `1px solid ${detectionType.toLowerCase().replaceAll(' ', '') === 'eventcompletion' ? SemanticInfo[500] : Christine[600]}`,
                height: 24,
            }}
        />
    );
};
